import { FC } from "react";
import classNames from "classnames";
import { dashHDP } from "../helper";
import { useChangeDetector } from "../useOddChangeDetector/useChangeDetector";
import { ArrowIcon } from "../icons";
import { Option } from "../types/common";

export type AHProps = {
  hdp?: string | number;
  label?: string;
  price?: string | number;
  className?: string;
  outcomeId: string;
  marketId: string;
  sp: string;
  matchId: string;
  leagueId: string;
  option: Option;
  minParlay?: number;
  onClick?: (data: {
    outcomeId: string;
    marketId: string;
    sp: string;
    matchId: string;
    leagueId: string;
    option: Option;
    minParlay?: number;
  }) => void;
};

const AH: FC<AHProps> = ({
  hdp,
  price,
  className,
  label,
  onClick = () => {},
  outcomeId,
  marketId,
  sp,
  matchId,
  leagueId,
  option,
  minParlay,
}) => {
  const { priceChangedType } = useChangeDetector(
    price || 0,
    `${outcomeId}` || "",
  );
  return (
    <div className={classNames("flex", className)}>
      {!!hdp && (
        <div
          className={classNames(
            "flex-1 text-xs font-semibold flex items-center justify-end",
            {
              "pr-2": !!label,
            },
          )}>
          <span className="text-blue-700">{dashHDP(hdp)}</span>
        </div>
      )}

      <div className="flex-1 flex justify-end">
        {!!label && !!price && (
          <div className="text-xs flex items-center font-semibold mr-1">
            {label}
          </div>
        )}
        {!!Number(price) && (
          <button
            onClick={() => {
              onClick({
                outcomeId,
                marketId,
                sp,
                matchId,
                leagueId,
                option,
                minParlay,
              });
            }}
            style={{ width: 40 }}
            className={classNames(
              "font-semibold hover:cursor-pointer flex justify-end",
              {
                "text-red-600": Number(price) < 0,
                "bg-red-100": priceChangedType === "decrease",
                "bg-green-200": priceChangedType === "increase",
              },
            )}>
            {price || ""}
            {
              <span
                className={`flex justify-center items-center opacity-0
    ${priceChangedType === "decrease" ? "arrow-down" : ""} 
    ${priceChangedType === "increase" ? "arrow-up" : ""}
    `}>
                <ArrowIcon
                  size={8}
                  color={
                    priceChangedType === "decrease" ? "#FF0000" : "#008000"
                  }
                />
              </span>
            }
          </button>
        )}
      </div>
    </div>
  );
};

export default AH;
